import  Axios  from 'axios';

export const getAxiosTotall=()=>{
    return Axios.create({
        baseURL:"https://api.electronicsteps.ir/",
        headers: {
            "x-auth-token": localStorage.getItem("clientElectronicToken")
        }
    })
}